import { createAction } from 'typesafe-actions';

export const changeFloornMinAction = createAction('filters/minFloornChanged')<number>();
